/**
 * useDateFnsLocale — the ONE mapping from the active i18n language to a
 * date-fns locale (German default, matching the app's locale set de/fr/en).
 * Components previously hand-rolled this ternary and had already diverged
 * (one consumer fell back to enUS while others fell back to de).
 */
import { useTranslation } from 'react-i18next';
import { de, enUS, fr } from 'date-fns/locale';

export function useDateFnsLocale() {
  const { i18n } = useTranslation();
  switch (i18n?.language) {
    case 'fr':
      return fr;
    case 'en':
      return enUS;
    default:
      return de;
  }
}
